import { combineReducers } from 'redux';
import { laminate, laminateConfigurationActions } from './ducks/laminate';

export const configurationsActions = {
  ...laminateConfigurationActions,
};

export const configurations = combineReducers({
  laminate,
});

export * from './ducks/selectors';
export * from './types';
